import controller from './empty-state.controller';

const template = require('./empty-state.html');

export default {
    bindings: {
        state: '@',
    },
    controller,
    template
};



// WEBPACK FOOTER //
// ./app/common/empty-state/empty-state.component.js